var map = {
	"./google-play-af_za.png": "./client/assets/images/store/google-play-af_za.png",
	"./google-play-am_et.png": "./client/assets/images/store/google-play-am_et.png",
	"./google-play-ar_001.png": "./client/assets/images/store/google-play-ar_001.png",
	"./google-play-az_az.png": "./client/assets/images/store/google-play-az_az.png",
	"./google-play-bs_ba.png": "./client/assets/images/store/google-play-bs_ba.png",
	"./google-play-cs_cz.png": "./client/assets/images/store/google-play-cs_cz.png",
	"./google-play-da_dk.png": "./client/assets/images/store/google-play-da_dk.png",
	"./google-play-de_de.png": "./client/assets/images/store/google-play-de_de.png",
	"./google-play-el_gr.png": "./client/assets/images/store/google-play-el_gr.png",
	"./google-play-en_gb.png": "./client/assets/images/store/google-play-en_gb.png",
	"./google-play-es_419.png": "./client/assets/images/store/google-play-es_419.png",
	"./google-play-es_us.png": "./client/assets/images/store/google-play-es_us.png",
	"./google-play-et_ee.png": "./client/assets/images/store/google-play-et_ee.png",
	"./google-play-fi_fi.png": "./client/assets/images/store/google-play-fi_fi.png",
	"./google-play-fr_ca.png": "./client/assets/images/store/google-play-fr_ca.png",
	"./google-play-fr_fr.png": "./client/assets/images/store/google-play-fr_fr.png",
	"./google-play-he_il.png": "./client/assets/images/store/google-play-he_il.png",
	"./google-play-hi_in.png": "./client/assets/images/store/google-play-hi_in.png",
	"./google-play-hu_hu.png": "./client/assets/images/store/google-play-hu_hu.png",
	"./google-play-it_it.png": "./client/assets/images/store/google-play-it_it.png",
	"./google-play-ja_jp.png": "./client/assets/images/store/google-play-ja_jp.png",
	"./google-play-ko_kr.png": "./client/assets/images/store/google-play-ko_kr.png",
	"./google-play-ms_my.png": "./client/assets/images/store/google-play-ms_my.png",
	"./google-play-nb_no.png": "./client/assets/images/store/google-play-nb_no.png",
	"./google-play-ne_np.png": "./client/assets/images/store/google-play-ne_np.png",
	"./google-play-nl_nl.png": "./client/assets/images/store/google-play-nl_nl.png",
	"./google-play-pl_pl.png": "./client/assets/images/store/google-play-pl_pl.png",
	"./google-play-pt_br.png": "./client/assets/images/store/google-play-pt_br.png",
	"./google-play-pt_pt.png": "./client/assets/images/store/google-play-pt_pt.png",
	"./google-play-ro_ro.png": "./client/assets/images/store/google-play-ro_ro.png",
	"./google-play-ru_ru.png": "./client/assets/images/store/google-play-ru_ru.png",
	"./google-play-sk_sk.png": "./client/assets/images/store/google-play-sk_sk.png",
	"./google-play-sl_si.png": "./client/assets/images/store/google-play-sl_si.png",
	"./google-play-so_so.png": "./client/assets/images/store/google-play-so_so.png",
	"./google-play-sv_se.png": "./client/assets/images/store/google-play-sv_se.png",
	"./google-play-sw_ke.png": "./client/assets/images/store/google-play-sw_ke.png",
	"./google-play-th_th.png": "./client/assets/images/store/google-play-th_th.png",
	"./google-play-tl_ph.png": "./client/assets/images/store/google-play-tl_ph.png",
	"./google-play-uk_ua.png": "./client/assets/images/store/google-play-uk_ua.png",
	"./google-play-vi_vn.png": "./client/assets/images/store/google-play-vi_vn.png",
	"./google-play-xh_za.png": "./client/assets/images/store/google-play-xh_za.png",
	"./google-play-zh_cn.png": "./client/assets/images/store/google-play-zh_cn.png",
	"./google-play-zh_hk.png": "./client/assets/images/store/google-play-zh_hk.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./client/assets/images/store sync recursive ^\\.\\/google\\-play\\-.*\\.png$";